import React from 'react';
import { PieChart as RechartsPie, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PieChart = ({ data, options = {}, fieldConfig = {} }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <span style={{ color: '#8c8c8c' }}>No data</span>
      </div>
    );
  }

  const COLORS = ['#1890ff', '#52c41a', '#faad14', '#ff4d4f', '#9254de', '#13c2c2', '#fa8c16', '#eb2f96'];

  // Determine if donut or pie
  const pieType = options.pieType || 'pie';
  const innerRadius = pieType === 'donut' ? 60 : 0;
  const showLegend = options.legend?.show ?? true;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RechartsPie>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={80}
          dataKey="value"
          label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
          labelLine={true}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip formatter={(value) => value.toLocaleString()} />
        {showLegend && (
          <Legend 
            verticalAlign="bottom" 
            height={36} 
            wrapperStyle={{ fontSize: '11px' }} 
          />
        )}
      </RechartsPie>
    </ResponsiveContainer>
  );
};

export default PieChart;